import { createFileRoute } from '@tanstack/react-router'
import { CatalogSourcesPage } from '@/pages/catalog-sources'

export const Route = createFileRoute('/_authenticated/catalog-sources')({
  staticData: { title: 'Catalog Sources' },
  component: CatalogSourcesPage,
})
